import config from '@/config'

export default class VindiHttpClient {
  constructor(basePath) {
    this._basePath = basePath
    this._headerTransformers = []
  }

  async post(path, body, includeCredentials) {
    let options = {
      method: 'POST',
      headers: await this._createHeaders(),
      body: JSON.stringify(body)
    }

    return this.sendRequest(path, options, includeCredentials)
  }

  async sendRequest(path, options, _includeCredentials) {
    return fetch(this._basePath + path, options)
  }

  async _createHeaders() {
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Basic ${config.vindiApiSecret}`
    })

    for (let transformer of this._headerTransformers) {
      headers = await transformer.transform(headers)
    }

    return headers
  }
}
